import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function ClassFeeForm() {
    const navigate = useNavigate();
    const { id } = useParams();

    const isEdit = Boolean(id);

    const [list, setList] = useState([]);

    const [formData, setFormData] = useState({
        session: "",
        className: "",
        status: "Active",
    });

    //  FIX: id matching
    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("classFee")) || [];

        setList(saved);

        if (isEdit && saved.length > 0) {
            const item = saved.find((l) => String(l.id) === String(id));
            if (item) setFormData(item);
        }
    }, [id, isEdit]);

    //  SAVE
    const handleSubmit = () => {
        if (!formData.session || !formData.className) {
            return alert("All fields required");
        }

        let updatedList = [];

        if (isEdit) {
            updatedList = list.map((l) =>
                String(l.id) === String(id)
                    ? { ...formData, id: l.id }
                    : l
            );
        } else {
            updatedList = [
                { ...formData, id: Date.now() },
                ...list,
            ];
        }
        localStorage.setItem("classFee", JSON.stringify(updatedList));
        setList(updatedList);

        navigate("/admin/classfee");
    };

    return (
        <div style={{ padding: "20px" }}>
            <h2>{isEdit ? "Update Class Fee" : "Add Class Fee"}</h2>

            <input
                placeholder="Session"
                value={formData.session}
                onChange={(e) =>
                    setFormData({ ...formData, session: e.target.value })
                }
            />

            <br /><br />

            <input
                placeholder="Class"
                value={formData.className}
                onChange={(e) =>
                    setFormData({ ...formData, className: e.target.value })
                }
            />

            <br /><br />

            <select
                value={formData.status}
                onChange={(e) =>
                    setFormData({ ...formData, status: e.target.value })
                }
            >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
            </select>

            <br /><br />

            <button onClick={handleSubmit}>
                {isEdit ? "Update" : "Save"}
            </button>

            <button onClick={() => navigate("/admin/classfee")}>
                Cancel
            </button>
        </div>
    );
}